export default __webpack_public_path__ + "static/media/Path3423.027fdc14.svg";